var map = {
	"./food1.jpg": "f642",
	"./food10.jpg": "9f85",
	"./food2.jpg": "8273",
	"./food3.jpg": "2cf9",
	"./food4.jpg": "b5d9",
	"./food5.jpeg": "820e",
	"./food6.jpg": "4bac",
	"./food7.jpg": "257e",
	"./food8.jpeg": "ff3d",
	"./food9.jpeg": "d9b5",
	"./thumbnail.py": "bb8e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c155";